import { Control, Controller } from 'react-hook-form'

import { Intent } from '../../config/intent'
import { Validation } from '../../lib/validation'
import { Select } from '../select'
import { ProfileInfoFormValues } from './profile-info-form'

interface RolesSelectProps {
    control: Control<ProfileInfoFormValues>
    intent: Intent
    value: string[]
    onChange: (value: string[]) => void
}

export function AvailableRolesSelect({
    control,
    intent,
    value,
    onChange,
}: RolesSelectProps) {
    const name = 'productInterests'

    return (
        <Controller
            name={name}
            control={control}
            rules={Validation.genericRequired}
            defaultValue={value}
            render={({ field }) => {
                return (
                    <Select
                        // @ts-ignore
                        options={[
                            {
                                label: 'Individual',
                                value: 'INDIVIDUAL',
                            },
                            {
                                label: 'Business',
                                value: 'BUSINESS',
                            },
                            // {
                            //     label: 'Liquidity Provider',
                            //     value: 'LIQUIDITY_PROVIDER',
                            // },
                            // {
                            //     label: 'Validator',
                            //     value: 'VALIDATOR',
                            // },
                        ]}
                        value={value}
                        intent={intent}
                        loading={false}
                        onChange={(selection: any, action: any) => {
                            onChange([selection.value])
                        }}
                    />
                )
            }}
        />
    )
}
